/**
 * Error code of the backend's 403 for document routes while the company's
 * access is suspended for an unpaid invoice (BILLING_SUSPEND_ENABLED).
 * Mirrors BILLING_SUSPENDED_CODE in apps/backend/src/billing-suspension.ts.
 */
export const BILLING_SUSPENDED_CODE = 'BILLING_SUSPENDED';

/** Toast id: many blocked requests at once show one message. */
export const BILLING_SUSPENDED_TOAST_ID = 'billing-suspended';

/** True for an RTK Query / baseQuery error that is a billing suspension. */
export function isBillingSuspendedError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const { status, data } = error as { status?: unknown; data?: unknown };
  return status === 403 && !!data && typeof data === 'object' && (data as { code?: unknown }).code === BILLING_SUSPENDED_CODE;
}
